import type { TypeFile } from '../step4/hooks/types';

export const CONTRACT_JOURNEY_APP_IDS = {
  step1: 'journey-contract-step1',
  step2: 'journey-contract-step2',
  step3: 'journey-contract-step3',
  completed: 'journey-contract-completed'
} as const;

export function contractStepField(step: 1 | 2 | 3, field: string): string {
  return `${CONTRACT_JOURNEY_APP_IDS[`step${step}`]}-${field}`;
}

export function contractUploadAppId(key: TypeFile): string {
  return `${CONTRACT_JOURNEY_APP_IDS.step2}-upload-${key.replace(/_/g, '-')}`;
}
